import { createSvg } from '../createSvg';

const Minus = (
    {
        strokeWidth = 1.5,
    },
): JSX.Element => {
    return (
        <>
            <g id={'guts'}>
                <path
                    d='M6 12H18'
                    strokeWidth={strokeWidth}
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </g>
        </>
    );
};

export default createSvg(
    Minus,
    'minus',
);
